// extracted by mini-css-extract-plugin
export default {"row":"createGame_row__rCwVS","col":"createGame_col__KP6UZ","card":"createGame_card__N9wfI"};